import { getOwner } from '@ember/application';
import { cached } from '@glimmer/tracking';

export default class BaseUrlHandler {
  @cached
  get rootURL() {
    return getOwner(this)
      .resolveRegistration('config:environment')
      .rootURL.replace(/\/$/, '');
  }

  async request({ request }, next) {
    if (request.url.startsWith('/') && this.rootURL) {
      request = Object.assign({}, request, {
        url: `${this.rootURL}${request.url}`,
      });
    }
    return next(request);
  }
}
